import {NgModule} from "@angular/core";
import {LocaleListComponent} from "./locale-list/locale-list.component";
import {LocaleFilterPipe} from "./locale.pipe";
import {LocaleSwitcherComponent} from "./locale-switcher.component";
import {SharedModule} from "../../shared.module";
import {FlagIconComponent} from "./flag.icon.component";


@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        FlagIconComponent,
        LocaleListComponent,
        LocaleFilterPipe,
        LocaleSwitcherComponent
    ],
    exports: [
        LocaleListComponent,
        FlagIconComponent
    ]
})
export class LocaleModule { }
